<template>
  <div ref="offersScreen" class="text-gray-600/95">
    <div v-if="showDynamicOffer" class="w-full space-y-4 py-4">
      <dynamic-offer :offers="offers" :dynamic-field-names="dynamicFields" />
    </div>
    <div v-else class="w-full space-y-4 py-4">
      <offer v-for="offer in offers" :key="offer.id" :offer="offer" />
    </div>
  </div>
</template>
<script setup lang="ts">
import DynamicOffer from "@/components/deals/workflow/BorrowerPlatform/BorrowerPlatformPreview/BorrowerPlatformDynamicOffer.vue";
import Offer from "@/components/deals/workflow/BorrowerPlatform/BorrowerPlatformPreview/BorrowerPlatformOffer.vue";

import type { OfferView } from "@/models/offers";

defineProps<{
  offers: OfferView[];
  dynamicFields: string[];
  showDynamicOffer: boolean;
}>();
</script>
